import * as R from "ramda";
import { createSelector } from "reselect";
import { getters } from "./model";
import * as STANDARD_MODULE_IDS from "@sessionboard/sessionboard-value-types/src/constants/standard-modules";
import {
  //   DOCUMENT_REQUEST_REVISIONS,
  DOCUMENT_REQUEST_TYPES
} from "utils/standard-module-field-ids";
import getValue from "utils/value-types/get-value";

// const { FILES, REVISION_STATUS } = DOCUMENT_REQUEST_REVISIONS;
const { SAMPLE_DOCUMENTS, CRITERIA } = DOCUMENT_REQUEST_TYPES;

import { TAB_IDS, TASK_TYPES, TABS } from "./constants";

export const getIsValid = R.always(true);

export const getTabs = createSelector(
  getters.taskData,
  getters.messages,
  (taskData, messages) => {
    const tabs =
      taskData.type !== TASK_TYPES.DOCUMENT_REQUEST
        ? R.omit([R.toUpper(TAB_IDS.MESSAGES)], TAB_IDS)
        : TAB_IDS;

    const messageLength = R.length(messages);
    const returnTabs = R.map(
      tab => ({
        id: tab,
        title:
          tab !== TAB_IDS.MESSAGES
            ? TABS.find(t => t.id === tab).title
            : `${TABS.find(t => t.id === tab).title}  ${
                messageLength > 0 ? `(${messageLength})` : ""
              }`
      }),
      R.values(tabs)
    );
    return returnTabs;
  }
);

export const getRequestType = createSelector(getters.record, record => {
  const { request_type_id = undefined } = record || {};
  return R.pathOr(
    {},
    [
      "expanded",
      STANDARD_MODULE_IDS.documentRequestTypes.id,
      "records",
      request_type_id
    ],
    record
  );
});

export const getRevisions = createSelector(getters.record, record => {
  const revisions = R.pathOr(
    {},
    ["expanded", STANDARD_MODULE_IDS.documentRequestRevisions.id, "records"],
    record
  );
  const sortedRevisions = R.pipe(
    R.map(id => revisions[id]),
    R.sortBy(r => new Date(r.created_at)),
    R.reverse
  )(Object.keys(revisions));
  return sortedRevisions;
});

export const getCriteria = createSelector(getRequestType, requestType => {
  const criteria = R.pathOr({}, ["values", CRITERIA], requestType);
  const value = getValue(criteria, "text");
  return value;
});

export const getSampleDocuments = createSelector(
  getRequestType,
  requestType => {
    const sampleDocuments = R.pathOr(
      {},
      ["values", SAMPLE_DOCUMENTS],
      requestType
    );
    const value = getValue(sampleDocuments, "file");
    return value;
  }
);

export const getMarkCompletedAsViewOnly = createSelector(
  getters.taskData,
  taskData => {
    return taskData?.meta?.markCompletedAsViewOnly && taskData?.is_complete
      ? true
      : false;
  }
);
